import type { FlowCompletionSummary, PublicFlowClientResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

/**
 * Public flow-instance split endpoints. These mirror the advisor's
 * `/internal/flow-instances/:id/metadata` + `/flow-definition` split, with two
 * extras (`/client`, `/tenant`) carved out so each per-resource read can be
 * cached independently and column-allowlisted at the DB.
 *
 * The legacy `/public/flow/instance` endpoint that bundles instance + client +
 * tenant + flow definition still exists today; the three reads below are the
 * dedicated per-resource replacements. Once frontend consumers move over to
 * these, the legacy endpoint is trimmed to instance metadata only.
 */

/** GET /public/flow/definition — wizard-transformed flow definition. */
export function getPublicFlowDefinition(token: string) {
  return getWithToken<any>("/public/flow/definition", token);
}

/** GET /public/flow/client — allowlisted client fields. */
export function getPublicFlowClient(token: string) {
  return getWithToken<PublicFlowClientResponse>("/public/flow/client", token);
}

/** GET /public/flow/tenant — allowlisted tenant branding. */
export function getPublicFlowTenant(token: string) {
  return getWithToken<any>("/public/flow/tenant", token);
}

/**
 * GET /public/flow/instance/completion — engine-driven completion/progress for
 * the public workflow (Follow-up C). Session-scoped, so no instanceId in the URL.
 */
export function getPublicFlowCompletion(token: string) {
  return getWithToken<FlowCompletionSummary>("/public/flow/instance/completion", token);
}
